import { combineReducers } from "redux";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import settingStoreCate from "./slices/settingStoreCateSlice";
import settingMenuCate from "./slices/settingMenuCateSlice";
import settingSystem from "./slices/settingSystemSlice";
import partner from "./slices/partnerSlice";
import location from "./slices/locationSlice";
import settingStoreUtility from "./slices/settingStoreUtilitySlice";
import storeApi from "./slices/storeSlice";
import attributeCate from "./slices/settingProductAttribute";
import product from "./slices/ProductSlice";
import storeWifi from "./slices/storeWifiSlice";
import storeTable from "./slices/storeDinnerTableSlice";
import settingBanner from "./slices/settingBannerSlice";
import customer from "./slices/CustomerSlice";
import employee from "./slices/EmployeeSlice";
import orderApi from "./slices/orderSlice";
import report from "./slices/reportSlice";
import notification from "./slices/NotificationSlice";
import post from "./slices/postSlice";
import shoppingCart from "./slices/shoppingCartSlice";
import postComment from "./slices/postCommentSlice";
import sInvoiceSlice from "./slices/InvoiceSlice";
import saasSlice from "./slices/saasSlice";
import settingGroupCateSlice from "./slices/settingGroupCateSlice";
import settingRatingCate from "./slices/settingRatingCateSlice";
import reportViolation from "./slices/reportViolationSlice";
import wordViolation from "./slices/wordViolationSlice";
import affiliate from "./slices/affiliateSlice";
import apiCredential from "./slices/apiCredentialSlice";
import apiSyncLog from "./slices/apiSyncLogSlice";
import misaApi from "./slices/misaSlice";
import warehouseApi from "./slices/warehouseSlice";
import addOptionApi from "./slices/storeAddOptionSlice";
import menuStoreApi from "./slices/settingMenuStoreSlice";
import warehouseReceiptApi from "./slices/warehouseReceiptSlice";
import customerStoreApi from "./slices/customerStoreSlice";
import commonCategoryApi from "./slices/commonCategorySlice";
import importExportApi from "./slices/importExportSlice";
import reportDetailApi from "./slices/reportDetailSlice";
import requestOrderApi from "./slices/requestOrderSlice";
import purchaseOrderApi from "./slices/purchaseOrderSlice";
import supplierPriceApi from "./slices/supplierPriceSlice";
import purchaseReportApi from "./slices/purchaseReportSlice";
import emailApi from "./slices/emailSlice";
import emailSenderApi from "./slices/emailSenderSlice";
import emailTemplateApi from "./slices/emailTemplateSlice";
import additionOptionApi from "./slices/AdditionOptionSlice";
import otherOptionApi from "./slices/OtherOptionSlice";
import permissionApi from "./slices/workspaceSlice";
import accessHistoryApi from "./slices/accessHistorySlice";
import semiProductApi from "./slices/SemiProductSlice";
import inventoryTransaction from "./slices/InventoryTransactionSlice";
import priceListApi from "./slices/PriceListSlice";
import purchaseCategoryApi from "./slices/purchaseCategorySlice";

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    storeApi,
    settingStoreCate,
    settingMenuCate,
    settingSystem,
    settingStoreUtility,
    partner,
    location,
    attributeCate,
    product,
    storeWifi,
    storeTable,
    settingBanner,
    customer,
    employee,
    orderApi,
    report,
    notification,
    post,
    shoppingCart,
    postComment,
    sInvoiceSlice,
    saasSlice,
    settingGroupCateSlice,
    settingRatingCate,
    reportViolation,
    wordViolation,
    affiliate,
    apiCredential,
    apiSyncLog,
    misaApi,
    warehouseApi,
    addOptionApi,
    menuStoreApi,
    warehouseReceiptApi,
    customerStoreApi,
    commonCategoryApi,
    importExportApi,
    reportDetailApi,
    requestOrderApi,
    purchaseOrderApi,
    supplierPriceApi,
    purchaseReportApi,
    emailApi,
    emailSenderApi,
    emailTemplateApi,
    additionOptionApi,
    otherOptionApi,
    permissionApi,
    accessHistoryApi,
    semiProductApi,
    inventoryTransaction,
    priceListApi,
    purchaseCategoryApi,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
